export default __webpack_public_path__ + "static/shop-image1-280ded5ad3fe26046a72eb317f593e6e.jpg";